var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"artist-box"},[_c('list',_vm._l((_vm.artist),function(value,key){return _c('list-item',{key:key},[_c('template',{slot:"key"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('template',{slot:"value"},[_vm._v(_vm._s(_vm._f("toString")(value)))])],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }